var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("contractKPIManagement.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.rsmEmpNo"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.rsmEmpNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "rsmEmpNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.rsmEmpName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.rsmEmpName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "rsmEmpName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.asmEmpNo"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.asmEmpNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "asmEmpNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.asmEmpName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.asmEmpName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "asmEmpName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.empNo"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.empName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("contractKPIManagement.form.year"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.year },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "year", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("contractKPIManagement.BoxWrap.list") },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("contractKPIManagement.common.exportText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.export")))]
                ),
                _vm._v(" "),
                _c("ImportExcel", {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["IMPORT"] },
                      expression: "{pageName, list: ['IMPORT']}",
                    },
                  ],
                  attrs: {
                    "is-loading": _vm.isLoading,
                    "opt-config": _vm.optConfig,
                  },
                  on: {
                    "update:isLoading": function ($event) {
                      _vm.isLoading = $event
                    },
                    "update:is-loading": function ($event) {
                      _vm.isLoading = $event
                    },
                    refresh: _vm.searchData,
                  },
                }),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.table.listLoading,
                  expression: "table.listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.table.list,
                stripe: "",
                border: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "rsmEmpNo",
                  label: _vm.$t("contractKPIManagement.table.rsmEmpNo"),
                  width: "120",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rsmEmpName",
                  label: _vm.$t("contractKPIManagement.table.rsmEmpName"),
                  width: "100",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "asmEmpNo",
                  label: _vm.$t("contractKPIManagement.table.asmEmpNo"),
                  width: "120",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "asmEmpName",
                  label: _vm.$t("contractKPIManagement.table.asmEmpName"),
                  width: "100",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("contractKPIManagement.table.empNo"),
                  width: "120",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("contractKPIManagement.table.empName"),
                  width: "100",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "year",
                  label: _vm.$t("contractKPIManagement.table.year"),
                  align: "left",
                  fixed: "",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oneSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.oneSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twoSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.twoSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "threeSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.threeSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fourSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.fourSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fiveSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.fiveSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sixSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.sixSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sevenSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.sevenSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "eightSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.eightSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nineSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.nineSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tenSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.tenSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "elevenSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.elevenSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twelveSigningTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.twelveSigningTargetQty"
                  ),
                  width: "125",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oneActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.oneActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twoActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.twoActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "threeActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.threeActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fourActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.fourActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fiveActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.fiveActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sixActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.sixActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sevenActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.sevenActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "eightActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.eightActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nineActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.nineActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tenActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.tenActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "elevenActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.elevenActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twelveActiveTargetQty",
                  label: _vm.$t(
                    "contractKPIManagement.table.twelveActiveTargetQty"
                  ),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.table.total > 0,
                expression: "table.total>0",
              },
            ],
            attrs: {
              total: _vm.table.total,
              page: _vm.table.currPage,
              limit: _vm.table.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.table, "currPage", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.table, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }